<template>
  <HttpContentView :endpoint="utilities.path('modules/wiki/categories/@', categoryId)">
    <template v-slot:content="{ data: category }">
      <HttpFormView :endpoint="!article ? utilities.path('modules/wiki/categories/@/articles', categoryId) : utilities.path('modules/wiki/articles/@', article?.id)" :method="!article ? 'post' : 'put'" :content="!article ? { published: true } : article" @update:content="emit('update:changes', !article || JSON.stringify($event) !== JSON.stringify(article))" @success="emit('success')">
        <template v-slot:form="{ content, errors, submit, loading }">
          <div class="d-flex flex-column g-4">
            <InputView type="text" :max="32" :value="content.name" @update:value="(content.slug ?? '') === utilities.slugify(content.name ?? '') ? content.slug = utilities.slugify($event) : undefined; content.name = $event" :title="translate('name')" :errors="errors.name" required/>
            <div>
              <InputView type="text" :max="64" :value="content.slug" @update:value="content.slug = utilities.slugify($event)" :title="translate('slug')" :errors="errors.slug" required>
                <template v-slot:extra>
                  <div class="bg-secondary p-1 rounded-3 text-foreground">
                    a-z, -, 0-9
                  </div>
                </template>
              </InputView>
              <div v-if="info.community && content.slug" class="text-muted small mt-2 ms-3">
                {{ info.community.domain ?? info.community.subdomain }}/wiki/{{ category.slug }}/{{ content.slug }}
              </div>
            </div>
            <CheckboxInputView :title="translate('published')" v-model:value="content.published" color="primary" :errors="errors.published"/>
            <RichTextInputView v-model:value="content.content" :features="contentFeatures" :errors="errors.content ? Array.isArray(errors.content) ? errors.content : [translate('richText.format.invalid')] : undefined"/>
            <div class="d-flex align-items-center g-4">
              <ButtonView type="normal" color="primary" class="w-100" @click="submit" :disabled="loading">
                <i v-if="loading" class="fas fa-spinner fa-spin"></i>
                {{ translate("save") }}
              </ButtonView>
              <ButtonView type="normal" color="secondary" class="w-100" @click="emit('cancel')" :disabled="loading">
                {{ translate("cancel") }}
              </ButtonView>
            </div>
          </div>
        </template>
      </HttpFormView>
    </template>
  </HttpContentView>
</template>

<script setup>
import {InputView, utilities, HttpContentView, ButtonView, HttpFormView, CheckboxInputView, richTextFeatures, RichTextInputView} from "@/niftybit";
import info from "../../../info";

const props = defineProps({
  categoryId: String,
  article: Object,
  changes: Boolean
});

const emit = defineEmits(["success", "cancel", "update:changes"]);

const contentFeatures = [
  richTextFeatures.paragraph.create(),
  richTextFeatures.text.create(),
  richTextFeatures.hardBreak.create(),
  richTextFeatures.heading.create(),
  richTextFeatures.textStyle.create(),
  richTextFeatures.codeBlock.create(),
  richTextFeatures.bulletList.create(),
  richTextFeatures.orderedList.create(),
  richTextFeatures.infoBox.create(),
  richTextFeatures.blockQuote.create(),
  richTextFeatures.textAlign.create(),
  richTextFeatures.code.create(),
  richTextFeatures.strikethrough.create(),
  richTextFeatures.bold.create(),
  richTextFeatures.underline.create(),
  richTextFeatures.italic.create(),
  richTextFeatures.link.create(),
  richTextFeatures.videoEmbed.create(),
  richTextFeatures.image.create().uploads(utilities.path("modules/wiki/categories/@/images", props.categoryId), "post", ["png", "jpg"])
];

</script>